type CarouselImage = {
    AnoFiscal: number
    Campana: number
    ImagenHorizontal: string
    ImagenVertical: string
}

type CarouselImagesResponse<T> = {
    code: number
    data: T
}

export type CarouselImages = CarouselImagesResponse<CarouselImage[]>

export enum StatusCode {
    BAD_REQUEST = 400,
    NOT_FOUND = 404,
    OK = 200,
    FATAL_ERROR = 500
}

export type UnlockReason =
    | "UNLOCKED"
    | "NOT_BLOCKED"
    | "USER_DISABLED"
    | "ZONE_BLOCKED"
    | "USER_INFO_ERROR"
    | "UNLOCK_FAILED"
    | "USER_NOT_FOUND"

export type UnlockUserResponse = {
    reason: UnlockReason
    message?: string
    blocked?: boolean
    enabled?: boolean
}

export type ApiMsg = {
    codigo?: number
    respuesta?: string
    servicio?: string
}

export type LoginResponse = {
    error?: string
    data?: Authenticate
}

export type Authenticate = {
    redirectTo: string
}